import {
  CardStyles as HygraphCardStyles,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { CardStyle } from '@/enums/card-style';

const map: Partial<Record<HygraphCardStyles, CardStyle>> = {
  [HygraphCardStyles.LightGrey]: CardStyle.LIGHT_GREY,
  [HygraphCardStyles.LightBlue]: CardStyle.LIGHT_BLUE,
  [HygraphCardStyles.LightPink]: CardStyle.LIGHT_PINK,
  [HygraphCardStyles.LightPurple]: CardStyle.LIGHT_PURPLE,
  [HygraphCardStyles.Transparent]: CardStyle.TRANSPARENT,
  [HygraphCardStyles.WhiteWithBorder]: CardStyle.WHITE_WITH_BORDER,
  [HygraphCardStyles.WideWhiteWithBorder]: CardStyle.WIDE_WHITE_WITH_BORDER,
  [HygraphCardStyles.ProfileStyle]: CardStyle.PROFILE_STYLE,
  [HygraphCardStyles.SmallWhiteCard]: CardStyle.SMALL_WHITE_CARD,
  [HygraphCardStyles.HorizontalImageText]: CardStyle.HORIZONTAL_IMAGE_TEXT,
  [HygraphCardStyles.AwardQuote]: CardStyle.AWARD_QUOTE,
};

export default function cardStyleTransformer(
  props: HygraphMaybe<HygraphCardStyles> | null
) {
  return props ? map[props] : undefined;
}
